var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpdateOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.03 6.97L14.78 1.72C14.63 1.57 14.48 1.5 14.25 1.5H5.25C4.42 1.5 3.75 2.17 3.75 3V21C3.75 21.82 4.42 22.5 5.25 22.5H12V21H5.25V3H12.75V7.5C12.75 8.32 13.43 9 14.25 9H18.75V12H20.25V7.5C20.25 7.27 20.18 7.12 20.03 6.97ZM14.25 7.5V3.3L18.45 7.5H14.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.71L13.06 17.77L15.75 15.08V24H17.25V15.08L19.93 17.77L20.99 16.71L16.5 12.21L12 16.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpdateOptions);
export default __webpack_public_path__ + "static/media/ic-update-options.6c779d05969a0ce0d2520c2f014fc812.svg";
export { ForwardRef as ReactComponent };